import React from 'react';
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom';
import { getLanguageFromURL } from '../utils/languageUtils';

interface LanguageAwareNavLinkProps extends Omit<NavLinkProps, 'to'> {
  to: string;
}

const LanguageAwareNavLink: React.FC<LanguageAwareNavLinkProps> = ({ to, ...props }) => {
  const currentLang = getLanguageFromURL();
  
  const getLanguageAwareTo = () => {
    if (currentLang) {
      const url = new URL(to, window.location.origin);
      url.searchParams.set('lang', currentLang);
      return url.pathname + url.search;
    }
    return to;
  };

  return <RouterNavLink {...props} to={getLanguageAwareTo()} />;
};

export default LanguageAwareNavLink; 